import type { FaireProductEntity } from "../../entity_types/product";

export const p_8v9tm78826: FaireProductEntity = {
  token: "p_8v9tm78826",
  type: "product",
  name: "Curious Elixir No. 2 Booze-Free Cocktails",
  brandToken: "b_3opsa00um8",
  brandName: "Curious Elixirs",
  imageUrl:
    "https://cdn.faire.com/fastly/c966d24e4b374222dddfb5409b6e88630d7c73b1ab043a09ba8628f95e3b6d02.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f8eff11fffc1194db4b548dfe003966e031bbd243516701ffbea5820e30904e.jpeg",
    "https://cdn.faire.com/fastly/ec8c3e52dd300f7e48cd167ca9a43fbadb5eda0dc85a51f47cfb650a3b0852ef.jpeg",
    "https://cdn.faire.com/fastly/421a20adadeec272927b4a5626b984ba9a214276dd9f47214ac27227acf3a820.png",
    "https://cdn.faire.com/fastly/f1b1d2db47989d7d129d2bbcc23c802d77f56ea5f07fe819e7d627fcd3dd4b40.jpeg",
  ],
  priceDollars: 89.38,
  description:
    "Spicy pineapple margarita meets a smoldering ginger Dark + Stormy, infused with damiana to help you unwind.\n\nCurious Elixir No. 2 is the spicy lovechild of the pineapple margarita and the Dark & Stormy, 100% booze-free. While citrus, ancho chili, jalapeño, and ginger wake up your taste buds, the ancient Mayan herb damiana will help you unwind. Enjoy on the rocks with a lime wedge and optional sea salt rim.",
  tags: [],
  msrpDollars: 178.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:48.571Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
